import { ENDPOINTS } from '../../constants/api'
import { madeRequest } from '../../helpers/api'

// PLOP_APPEND_PATTERN_ANCHOR

export function getPartnershipsService(params) {
  return madeRequest('GET', {
    params,
    url: ENDPOINTS.partnerships
  })
}

export function createPartnershipService(data) {
  return madeRequest('POST', {
    data,
    url: ENDPOINTS.partnerships
  })
}

export function updatePartnershipService(id, data) {
  return madeRequest('PATCH', {
    data,
    url: `${ENDPOINTS.partnerships}${id}/`
  })
}

export function deletePartnershipService({ id }) {
  return madeRequest('DELETE', {
    url: `${ENDPOINTS.partnerships}${id}/`
  })
}

export function sendOutstandingActionsNotificationService(partnershipId) {
  return madeRequest('GET', {
    url: `${ENDPOINTS.partnerships}${partnershipId}/send_outstanding_actions_notification/`
  })
}
